<template>
  <div class="home-index" id="home-index">
    <div class="left-main">
      <div class="top-a card-box">
        <div class="main">
          <div class="item" @click="clickMarbItem('2', '/zxk/search/index')">
            <img src="@/assets/newicons/ia01.png" alt="">
            <p>企业搜索</p>
          </div>
          <div class="item" @click="clickMarbItem('3', '/zxk/search/newlyCompany')">
            <img src="@/assets/newicons/ia02.png" alt="">
            <p>新企搜索</p>
          </div>
          <div class="item" @click="clickMarbItem('6', '/zxk/junbros/advancedSearch')">
            <img src="@/assets/newicons/ia03.png" alt="">
            <p>高级搜索</p>
          </div>
          <div class="item" @click="clickMarbItem('7', '/zxk/junbros/map')">
            <img src="@/assets/newicons/ia04.png" alt="">
            <p>商机地图</p>
          </div>
          <div class="item" @click="clickMarbItem('8', '/zxk/junbros/intelRecommend')">
            <img src="@/assets/newicons/ia05.png" alt="">
            <p>智能推荐</p>
          </div>
          <!-- <div class="item"  @click="clickMarbItem('4', '/zxk/search/biddingInquiry')">
              <img src="@/assets/newicons/ia06.png" alt=""> -->
          <div class="item" @click="clickMarbItemUpgrade()">
            <img src="@/assets/newicons/ia06-gray.png" alt="">
            <p>招标查询</p>
          </div>
        </div>
      </div>
      <div class="left-main-2 card-box">
        <el-row class="title">销售动态 <span>最近30天</span></el-row>
        <el-row class="main" v-loading="loading1">
          <el-col :span="12" :class="['item',this.neiqian?'nqClueUnlock':'']">
            <div class="l">
              <p class="sub-title">线索解锁数</p>
              <div class="number" style="position: relative;z-index: 10;">
                <span class="max">{{ companyDataObject.count || 0 }}</span>
                <span class="min">{{ companyDataObject.growthPercent || 0 }}</span>
                <el-tooltip class="item tipClass" effect="dark" content="解锁企业数近30天环比增长率" placement="top">
                  <i class="el-icon-caret-bottom min-icon" style="display: inline;"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="r" style="padding-right: 44px;padding-left:9px">
              <div class="canvas-main" id="clueUnlockChart"></div>
            </div>
          </el-col>
          <el-col :span="12" class="item" v-show="!neiqian">
            <div class="l">
              <p class="sub-title">转线索数</p>
              <div class="number" style="position: relative;z-index: 10;">
                <span class="max">{{ clueDataObject.count || 0 }}</span>
                <span class="min">{{ clueDataObject.growthPercent || 0 }}</span>
                <el-tooltip class="item tipClass" effect="dark" content="转线索数近30天环比增长率" placement="top">
                  <i class="el-icon-caret-bottom min-icon" style="display: inline;"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="r" style="padding-right: 1px;padding-left:9px">
              <div class="canvas-main" id="clueGetChart"></div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="left-box-3-main">
        <div class="left-box-3">
          <div class="left-main-3 card-box">
            <p class="title">解锁来源统计</p>
            <pieChart v-loading="loading2" :dataOptions="pieUnlockSourceData"></pieChart>
          </div>
          <div class="left-main-3-cover">
            <div class="title">臻寻客智能获客云平台</div>
            <div class="desc">随时随地找线索商机发现快一步</div>
            <div class="but" @click="clickMarbItem('2', '/zxk/search/index')">立即进入</div>
            <img src="@/assets/newicons/id01.png" class="cls002" alt="">
          </div>
        </div>
        <div class="left-box-4">
          <div class="left-main-4 card-box">
            <p class="title">员工解锁排行</p>
            <div class="line"></div>
            <div class="list" v-loading="loading7" v-if="employeeUnLockRankData.length > 0">
              <div class="box" v-for="(item,index) in employeeUnLockRankData" :key="index">
                <div :class="{'order-box': true,'order': index < 3}">{{ index + 1 }}</div>
                <div class="a1">
                  <el-tooltip effect="dark" v-if="(item.nickName && item.nickName.length > 5) || item.accountId === item.companyId"
                    :content="item.accountId === item.companyId ? '臻寻客超级管理员' : item.nickName" placement="top">
                    <span>{{item.accountId === item.companyId ? '臻寻客超级管理员' : item.nickName }}</span>
                  </el-tooltip>
                  <span v-else>{{ item.nickName || '--' }}</span>
                </div>
                <div class="a2">
                  <el-progress v-if="showPercentage" :percentage="parseInt(item.total > 100 ? 100 : item.total) || 0" :show-text="false" color="#5088FF" :stroke-width="8"></el-progress>
                </div>
                <div class="a3">
                  <el-tooltip effect="dark" v-if="item.total && item.total.length > 4" :content="item.total" placement="top">
                    <span style="font-size:12px">{{ item.total }}</span>
                  </el-tooltip>
                  <span v-else style="font-size:12px">{{item.total || 0}}</span>
                </div>
              </div>
            </div>
            <div class="emipy" v-else>
              <div class="sub-emipy">
                <div>
                  <img :src="emptyBox" alt="" srcset="">
                </div>
                <p>暂无数据</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-col :span="24">
        <el-card class="left-main-5">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="最近解锁动态" name="1">
              <div class="list" v-if="unlockCompanyData.length" v-loading="loading3">
                <div class="item" v-for="(item) in unlockCompanyData" :key="item.id">
                  <div class="box" v-if="item.source == 1">
                    <div class="a1">
                      <el-avatar v-if="item.avatarUrl" :size="36" :src="item.avatarUrl"></el-avatar>
                      <div v-else class="dongtaimt">{{ item.nickName ? item.nickName.slice(0, 1) : '--' }}</div>
                    </div>
                    <div class="a2">
                      <el-tooltip class="b1" effect="dark" v-if="(item.nickName && item.nickName.length > 4) || item.accountId === item.createrId"
                        :content="item.accountId === item.createrId ? '臻寻客超级管理员' : item.nickName" placement="top">
                        <span>{{ item.accountId === item.createrId ? '臻寻客超级管理员' : item.nickName }}</span>
                      </el-tooltip>
                      <span class="b1" v-else>{{ item.nickName || '--' }}</span>
                      <span class="b2">解锁了企业</span>
                      <span class="b3" @click="companyInfoClick(item,'a')">{{ item.companyName || '--' }}</span>
                      <div class="a3" style="font-family: Arial;">{{ item.createTime || '--' }}</div>
                    </div>
                  </div>
                  <div class="box" v-else>
                    <div class="a1">
                      <el-avatar size="medium" :src="item.avatarUrl"></el-avatar>
                    </div>
                    <div class="a2">
                      <span class="b1">{{ item.accountId === item.createrId ? '臻寻客超级管理员' : item.nickName ? item.nickName : '--' }}</span>
                      <span class="b2">解锁了评论</span>
                      <span class="b2">{{ item.companyName || '--' }}</span>
                      <div class="a3">{{ item.createTime || '--' }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="no-data" v-else>
                <div class="no-data-box">
                  <div>
                    <img :src="emptyBox" alt="" srcset="">
                  </div>
                  <p>暂无数据</p>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="号码清洗" name="2" v-if="!neiqian">
              <div class="list" v-if="numberCleaningCompanyData.length" v-loading="loading3">
                <div class="item" v-for="(item) in numberCleaningCompanyData" :key="item.id">
                  <div class="box">
                    <div class="a1">
                      <el-avatar v-if="item.avatarUrl" :size="36" :src="item.avatarUrl"></el-avatar>
                      <div v-else class="dongtaimt">{{ item.nickName ? item.nickName.slice(0, 1) : '--' }}</div>
                    </div>
                    <div class="a2">
                      <span class="b1">{{ item.nickName || '--' }}</span>
                      <span class="b2">创建了清洗任务</span>
                      <span class="b3" @click="goCleaningList">{{ item.name || '--' }}</span>
                      <div class="a3" style="font-family: Arial;">{{ item.createTime || '--' }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="no-data" v-else>
                <div class="no-data-box">
                  <div>
                    <img :src="emptyBox" alt="" srcset="">
                  </div>
                  <p>暂无数据</p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <!-- 跳转解锁列表 -->
          <template v-if="activeName == 1">
            <el-link class="goList" :underline="false" @click="goUnlockList">全部>></el-link>
            <pagination-new class="page001" :indexPg="false" v-if="unlockCompanyData && unlockCompanyData.length>0" :maxPageNum="maxPageNum" :pageNum="pageNum"
              @currentChange="handleCurrentChange"></pagination-new>
          </template>
          <template v-if="activeName == 2">
            <el-link class="goList" :underline="false" @click="goCleaningList">全部>></el-link>
            <pagination class="page001 cleaningPage" v-if="numberCleaningCompanyData&&numberCleaningCompanyData.length>0" :total="allTotalC" @currentChange="handleCurrentChange"
              @sizeChange="handleSizeChange" :pageNum="pageNumC" :pageSize="pageSizeC"></pagination>
          </template>

        </el-card>
      </el-col>
    </div>
    <div class="right-main">
      <el-row :gutter="20">
        <el-col class="m-b16" :span="24">
          <el-card class="left-main-6">
            <div class="main">
              <div class="top">
                <div class="title">权益额度统计</div>
                <img src="@/assets/newicons/ia07.png" class="cls001" alt="">
              </div>
              <!-- <p >权益额度统计</p> -->
              <div class="tongji" v-loading="loading4">
                <div class="box">
                  <div class="info">
                    <div class="name" style="font-size:13px">个人解锁权益使用总条数</div>
                    <div class="number">{{ prsonalInterest.usedTotal || 0 }}/{{ prsonalInterest.total }}</div>
                  </div>
                  <el-progress class="progress" :stroke-width="8" v-if="!isNaN(parseInt((prsonalInterest.usedTotal / prsonalInterest.total) * 100))"
                    :percentage="parseInt((prsonalInterest.usedTotal / prsonalInterest.total) * 100)" :show-text="false"></el-progress>
                </div>
                <div class="box">
                  <div class="info">
                    <div class="name" style="font-size:13px">企业解锁权益使用总条数</div>
                    <div class="number">{{ companyInterest.usedTotal || 0 }}/{{ companyInterest.total }}</div>
                  </div>
                  <el-progress class="progress" :stroke-width="8" v-if="!isNaN(parseInt((companyInterest.usedTotal / companyInterest.total)*100))"
                    :percentage="parseInt((companyInterest.usedTotal / companyInterest.total) * 100)" :show-text="false"></el-progress>
                </div>
                <div class="exp-time">
                  <div class="box1">
                    <div class="sub-box">权益到期日：{{ closeDate || '--' }}</div>
                    <div class="sub-box">距离到期还有：{{ durationDays || '--' }}天</div>
                  </div>
                </div>
              </div>
              <div class="tongji" v-if="!neiqian" v-loading="loading4">
                <div class="box">
                  <div class="info">
                    <div class="name" style="font-size:13px">个人号码清洗权益使用总条数</div>
                    <div class="number">{{ phonePersonInterest.usedTotal || 0 }}/{{ phonePersonInterest.total }}</div>
                  </div>
                  <el-progress class="progress person-cleaning" :stroke-width="12" :percentage="0" :text-inside="true" :format="setItemText"></el-progress>
                </div>
                <div class="box">
                  <div class="info">
                    <div class="name" style="font-size:13px">企业号码清洗权益使用总条数</div>
                    <div class="number">{{ phoneCompanyInterest.usedTotal || 0 }}/{{ phoneCompanyInterest.total }}</div>
                  </div>
                  <el-progress class="progress" :stroke-width="8" :percentage="parseInt((phoneCompanyInterest.usedTotal / phoneCompanyInterest.total) * 100) || 0" :show-text="false"></el-progress>
                </div>
                <div class="exp-time">
                  <div class="box1">
                    <div class="sub-box">权益到期日：{{ phoneCloseDate || '--' }}</div>
                    <div class="sub-box">距离到期还有：{{ phoneDays || '--' }}天</div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col class="m-b16" :span="24" v-if="false">
          <el-card class="left-main-7">
            <div class="title">
              <p>企业资讯</p>
              <p class="sub-title" @click="looksMore">查看更多 ></p>
            </div>
            <div class="main" v-loading="loading5">
              <template v-if="news.length > 0">
                <div :class="['item', index == 3?'nob':'']" v-for="(item, index) in news" :key="index">
                  <a class="a1 textOverflow" :href="item.uri" target="about">{{item.title}}</a>
                  <div class="a2" v-html="item.abstracts"></div>
                  <div class="a3">来源：<a style="margin-right:18px" :href="item.uri" target="about">{{item.website}}</a> 发布时间：<span>{{item.rtm | getTime}}</span></div>
                  <div class="a4">相关企业：<span style="color:rgba(80, 136, 255, 1);cursor: pointer;" @click="companyInfoClick(item,'b')">{{item.companyName}}</span></div>
                </div>
              </template>
              <div style="text-align: center;padding-top: 100px;" class="emptyBox" v-else>
                <div>
                  <div>
                    <img :src="emptyBox" alt="" srcset="">
                  </div>
                  <p>最新收藏企业的最新资讯展示在这里</p>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col class="m-b16 business-subscribe" :span="24">
          <el-card class="left-main-8">
            <div class="title">
              <p>商机订阅</p>
              <p class="sub-title" v-if="businessSubscribeInfo.length" @click="goSubscribe">查看全部 ></p>
            </div>
            <div class="list" v-loading="loading8" v-if="businessSubscribeInfo.length > 0">
              <div class="box" v-for="(item,index) in businessSubscribeInfo" :key="index">
                <div class="ixon" v-if="item.logoPath"><img :src="item.logoPath" alt="" srcset="" @error.once="item.logoPath = null"></div>
                <div class="ixon" v-else :class="['logo2',{'aliasLineHeight': aliasLineHeight}]" :style="'background:'+ bgColor[item.color]">{{setLineHeight(item.alias, item.companyName)}}</div>
                <div class="subscribe-txt">
                  <p class="a2" @click="companyInfoClick(item,'d')">{{ item.companyName || '--' }}</p>
                  <p class="a3">{{ item.subscriptionName || '--' }}</p>
                  <p class="a4">{{item.businessTime}}</p>
                </div>
              </div>
            </div>
            <div v-else class="detail" style="height:230px;position: relative;text-align: center;" v-loading="loading5">
              <div class="emptyBox">
                <div>
                  <div>
                    <!-- <img :src="emptyBox" alt="" srcset=""> -->
                    <img src="@/assets/subscribe/empty.png" class="kbImg">
                  </div>
                  <p>还没有订阅商机</p>
                  <el-button type="primary" @click="addSubscribe('add')">立即订阅</el-button>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="24">
          <el-card class="left-main-8">
            <p class="title">最近访问</p>
            <div class="list" v-loading="loading6" v-if="recentViewCompanyData.length > 0">
              <div class="box" v-for="(item,index) in recentViewCompanyData" :key="index">
                <div class="ixon" v-if="item.logoPath"><img :src="item.logoPath" alt="" srcset="" @error.once="item.logoPath = null"></div>
                <div class="ixon" v-else :class="['logo2',{'aliasLineHeight': aliasLineHeight}]" :style="'background:'+ bgColor[item.color]">{{setLineHeight(item.alias, item.companyName)}}</div>
                <p class="a2" style="cursor: pointer;" @click="companyInfoClick(item,'c')">{{ item.companyName || '--' }}</p>
                <p class="a3">{{ item.createTime || '--' }}</p>
              </div>
            </div>
            <div v-else class="detail" style="height:230px;position: relative;text-align: center;" v-loading="loading5">
              <div class="emptyBox">
                <div>
                  <div>
                    <img :src="emptyBox" alt="" srcset="">
                  </div>
                  <p>最近访问的企业展示在这里</p>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>

      </el-row>
    </div>
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
    <!-- 查看号码抽屉 -->
    <ViewNumber ref="vNumber" v-if="drawerShow!==null" :show.sync="drawerShow" :companyStatus="companyStatus" @unlock-change="unlockChange" />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import * as echarts from 'echarts'
import emptyBox from '@/assets/emptyBox.svg'
import pagination from '@/components/pagination'
import paginationNew from '@/components/pagination-new/index.vue'
import { getNews, searchByName, subscribeTop } from '@/views/clue/api/newClueApi'
import ViewNumber from '@/components/viewNumber'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import pieChart from '../components/pieChart.vue'
// eslint-disable-next-line import/no-cycle
import { cueQuotaStatistics, employeeUnLockRank, recentViewCompany, salesData, subscribeBusiness, unlockCompany, unlockSource } from '../api'
import { cleaningNumberList } from '@/views/clue/api/cleaningApi'
// import lineChart from './components/lineChart.vue'
import { X_BLOCK } from '@/utils/iframeUtils'
import RightFloat from '@/components/rightFloatBtn'
export default {
  data() {
    return {
      drawerShow: null,
      isRoll: false,
      rollTime: null,
      neiqian: false,
      emptyBox,
      searchNewsName: '',
      activeName: '1',
      circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      myChart: '',
      companyInterest: {}, // 企业权益条数
      giftInterest: {}, // 赠送权益条数
      prsonalInterest: {}, // 个人额度
      pieUnlockSourceData: [], // 解锁来源统计
      clueDataObject: {}, // 销售动态---线索领取数
      companyDataObject: {}, // 销售动态---线索解锁数
      clueUnlockChartData: [], // 销售动态---线索领取数---chart的数据接收
      clueUnlockChartXData: [],
      clueGetChartData: [], // 销售动态---线索解锁数---chart的数据接收
      clueGetChartXData: [],
      pageNum: 1,
      maxPageNum: 1,
      pageSize: 6,
      allTotal: 0,
      unlockCompanyData: [],
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      loading5: false,
      loading6: false,
      loading7: false,
      loading8: false,
      employeeUnLockRankData: [],
      recentViewCompanyData: [],
      news: [],
      showPercentage: false,
      durationDays: '',
      closeDate: '',
      aliasLineHeight: false,
      bgColor: ['#7DB3D9', '#84CAB0', '#8CA3CD', '#BC9EDD'],
      companyStatus: {
        companyName: '',
        hid: '',
        name: '',
        lockStatus: false,
        contactCount: {},
        companyView: {}
      },
      companyName: '',
      unlock: false,
      hid: '',
      businessSubscribeInfo: [],
      numberCleaningCompanyData: [],
      phonePersonInterest: {},//个人清洗权益条数
      phoneCompanyInterest: {},//企业清洗权益条数
      phoneCloseDate: '',//权益到期日期  
      phoneDays: '',//距离到期还有
      pageNumC: 1,
      maxPageNumC: 1,
      pageSizeC: 10,
      allTotalC: 0
    }
  },
  components: {
    pieChart,
    pagination,
    paginationNew,
    ViewNumber,
    RightFloat
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus,
      staffInfo: state => state.user.staffInfo,
      landingPageFlag: state => state.user.landingPageFlag
    })
  },
  watch: {
    companyDataObject() {
      if (this.companyDataObject) {
        this.$nextTick(() => {
          this.clueUnlockChart()
        })
      }
    },
    clueDataObject() {
      if (this.clueDataObject) {
        this.$nextTick(() => {
          this.clueGetChart()
        })
      }
    }
  },
  created() {

  },
  mounted() {
    this.getSubscribeTop()
    this.getNews()
    this.getCueQuotaStatistics()
    this.getRecentViewCompany()
    this.getSalesData()
    // this.getSubscribeBusiness()
    this.getUnlockCompany()
    this.getUnlockSource()
    this.getEmployeeUnLockRank()
    // this.testUserInfo()

    if (window[X_BLOCK]) {
      this.neiqian = true
    }

    this.getcleaningNumberList()

    // window.addEventListener('mousewheel',this.mousewheelFn)
    // this.$once('hook:beforeDestroy', () => {
    //   window.removeEventListener('mousewheel',this.mousewheelFn)
    // })
  },
  filters: {
    getTime(val) {
      const nowTime = Date.parse(new Date()) // 当前时间戳
      const year = (nowTime - val) / (12 * 30 * 24 * 60 * 60 * 1000)
      if (year > 1) return Math.floor(year) + '年前'
      const month = (nowTime - val) / (30 * 24 * 60 * 60 * 1000)
      if (month > 1) return Math.floor(month) + '月前'
      const day = (nowTime - val) / (24 * 60 * 60 * 1000)
      if (day > 1) return Math.floor(day) + '天前'
      const hour = (nowTime - val) / (60 * 60 * 1000)
      if (hour > 1) return Math.floor(hour) + '小时前'
      const min = (nowTime - val) / (60 * 1000)
      if (min > 1) return Math.floor(min) + '分钟前'
    }
  },
  methods: {
    setItemText() {
      return "无限制"
    },
    addSubscribe(type) {
      console.log('landingPageFlag', this.landingPageFlag)
      // 是否是演示账号
      if (this.staffInfo.demonstrationTag == 1) {
        this.$message({
          message: '演示账号，无法使用此功能',
          type: 'error'
        });
        return false
      }
      if (this.landingPageFlag) {
        this.$router.push('/zxk/junbros/subscribeList')
      } else {
        this.$router.push('/zxk/junbros/subscribeManagement?ld=true&type=' + type)
      }
    },
    // 商机订阅
    getSubscribeTop() {
      this.loading8 = true
      subscribeTop().then(res => {
        this.loading8 = false
        if (res.code == 200) {
          this.businessSubscribeInfo = res.data
        }
      }).catch(error => {
        this.loading8 = false
      })
    },
    goSubscribe() {
      this.$router.push('/zxk/junbros/subscribeList')
    },
    goUnlockList() {
      if (window.__sendIframeLinkMessage({ type: '11' })) return
      this.$router.push('/zxk/talkManage/unlockList')
    },
    goCleaningList() {
      this.$router.push('/zxk/junbros/numberCleaningList')
    },
    mousewheelFn(e) {
      this.isRoll = true
      if (this.rollTime) {
        clearTimeout(this.rollTime)
      }
      this.rollTime = setTimeout(() => {
        this.isRoll = false
      }, 50)
    },
    // 抽屉关闭得返回事件
    getBack() {
      this.getRecentViewCompany()
    },
    clickMarbItem(type, path) {
      if (window.__sendIframeLinkMessage({ type })) return
      this.$router.push(path)
    },
    // 招标入口隐藏
    clickMarbItemUpgrade() {
      return this.$message.warning('功能升级中，暂未开放')
    },
    handleBusinessClick() {
      return this.$message.warning('“功能升级中，敬请期待”')
    },
    companyInfoClick(obj, type) {
      // 是否是演示账号
      if (type == 'a' && this.staffInfo.demonstrationTag == 1) {
        this.$message({
          message: '演示账号，无法使用此功能',
          type: 'error'
        });
        return false
      }
      // 是否是演示账号
      if ((type == 'c' || type == 'd') && this.staffInfo.demonstrationTag == 1 && obj.unlock) {
        this.$message({
          message: '演示账号，无法使用此功能',
          type: 'error'
        });
        return false
      }
      if (this.surplus < 1 && !obj.unlock) { // 没有剩余条数则提示
        this.$store.dispatch('PERMISSION_CONFIRM')
        return
      }
      if (window.__sendIframeMessage(obj)) return

      this.companyName = obj.companyName
      this.unlock = obj.unlock
      this.hid = obj.hid

      this.companyStatus = { companyName: this.companyName, lockStatus: true, hid: obj.hid }
      this.reqSearchByName()
      this.drawerShow = true
    },

    unlockChange() {
      this.companyStatus = { ...this.companyStatus, unlock: true }
    },
    async reqSearchByName() {
      const { data } = await searchByName({ name: this.companyStatus.companyName, hid: this.companyStatus.hid })
      this.companyStatus = { ...data.items[0], companyName: this.companyStatus.companyName, hid: data.items[0].hid, lockStatus: data.items[0].unlock, }
    },

    clueUnlockChart() {
      this.chsrtaItem('clueUnlockChart', this.clueUnlockChartData, this.clueUnlockChartXData)
    },
    clueGetChart() {
      this.chsrtaItem('clueGetChart', this.clueGetChartData, this.clueGetChartXData)
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    chsrtaItem(dom, data, Xdata) {
      let myChart = null
      myChart = echarts.init(document.getElementById(dom))
      window.addEventListener('resize', () => {
        setTimeout(() => {
          myChart && myChart.resize()
        }, 800)
      })
      // if (this.myChart == null) { // 如果不存在，就进行初始化
      //   this.myChart = echarts.init(document.getElementById(dom))
      // }
      // let myChart = this.$echarts.init(document.getElementById(dom))

      const option = {
        grid: {
          top: '10px',
          left: '10px',
          right: '10px',
          bottom: '10px',
          containLabel: true
        },
        xAxis: [
          {
            show: false,
            type: 'category',
            position: 'top',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#eee'
              }
            },
            splitArea: {
              color: '#f00',
              lineStyle: {
                color: '#f00'
              }
            },
            axisLabel: {
              show: false,
              color: '#eee'
            },
            splitLine: {
              show: true
            },
            axisTick: {
              show: false
            },
            boundaryGap: false,
            data: Xdata
          }
        ],
        tooltip: {
          backgroundColor: 'rgba(66, 131, 245, 0.61)',
          borderWidth: 1,
          borderColor: 'rgba(66,131,245,0.2400)',
          extraCssText: 'backdrop-filter: blur(1px);width:114px;height:57px',
          padding: 10,
          textStyle: {
            color: '#fff',
            fontSize: '12px',
            lineHeight: 20,

          },
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          }
        },
        yAxis: [
          {
            type: 'value',
            min: 0,
            splitNumber: 4,
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false,
              margin: 20,
              textStyle: {
                color: '#d1e6eb'
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            type: 'line',
            smooth: true, // 是否平滑
            showAllSymbol: false,
            symbol: 'circle',
            symbolSize: 10,

            lineStyle: {
              normal: {
                color: 'rgba(70, 107, 255, 1)',
                shadowColor: 'rgba(0, 0, 0, .3)'
              }
            },
            label: {
              show: false,
              position: 'top',
              textStyle: {
                color: '#4076E2'
              }
            },
            itemStyle: {
              color: '#ffffff',
              borderColor: 'rgba(70, 107, 255, 1)',
              borderWidth: 2,
              shadowColor: 'rgba(0, 0, 0, .3)',
              shadowBlur: 0
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'RGBA(36, 110, 244, 0.65)'
                },
                {
                  offset: 0.1,
                  color: 'rgba(36, 110, 244, 0.58)'
                },
                {
                  offset: 1,
                  color: 'rgba(36, 110, 244, 0)'
                }
                ], false)
              }
            },
            data: data
          }
        ]
      }
      // 绘制图表
      myChart.setOption(option)
    },

    // 线索额度统计
    getCueQuotaStatistics() {
      this.loading4 = true
      cueQuotaStatistics().then(res => {

        // const numArticle = res.data.companyInterest.total - res.data.companyInterest.usedTotal
        // if (numArticle <= 0) { // 没有剩余条数则提示
        //   this.$store.dispatch('PERMISSION_CONFIRM')
        // }
        this.companyInterest = res.data.companyInterest
        this.giftInterest = res.data.giftInterest
        this.prsonalInterest = res.data.prsonalInterest
        this.closeDate = res.data.closeDate ? res.data.closeDate.split(' ')[0] : ''
        this.durationDays = res.data.durationDays ? res.data.durationDays : ''

        this.phonePersonInterest = res.data.phonePersonInterest
        this.phoneCompanyInterest = res.data.phoneCompanyInterest
        this.phoneCloseDate = res.data.phoneCloseDate ? res.data.phoneCloseDate.split(' ')[0] : ''
        this.phoneDays = res.data.phoneDays ? res.data.phoneDays : ''

        if (this.prsonalInterest.total === 0) {
          this.prsonalInterest.total = 100
        }
        if (this.giftInterest.total === 0) {
          this.giftInterest.total = 100
        }
        if (this.companyInterest.total === 0) {
          this.companyInterest.total = 100
        }

        if (this.phonePersonInterest.total === 0 || this.phonePersonInterest.total == null) {
          this.phonePersonInterest.total = '--'
        }
        //  if(this.phoneCompanyInterest.total === 0){
        //   this.phoneCompanyInterest.total = 100
        // }

        this.loading4 = false

      }).catch(error => {
        this.loading4 = false
        console.log(error)
      })
    },
    setLineHeight(val, name) {
      if (val && val.length > 0 && val.length < 3) {
        this.aliasLineHeight = true
      }
      const zz = /[\u4e00-\u9fa5]/g
      // if (val) return val.substr(0, 4)
      // return name.match(zz) && name.match(zz).join('').substr(0, 4)
      if (val) {
        return val.substr(0, 4)
      } else {
        if (name.match(zz)) {
          return name.match(zz).join('').substr(0, 4)
        } else {
          return name.substr(0, 4)
        }
      }
    },
    // 员工解锁排行
    getEmployeeUnLockRank() {
      this.loading7 = true
      employeeUnLockRank().then(res => {
        this.employeeUnLockRankData = res.data.slice(0, 10)
        this.showPercentage = true
        this.loading7 = false
      }).catch(error => {
        console.log(error)
        this.loading7 = false
      })
    },

    // 最近访问
    getRecentViewCompany() {
      this.loading6 = true
      recentViewCompany().then(res => {
        this.recentViewCompanyData = res.data
        this.loading6 = false
      }).catch(error => {
        this.loading6 = false
        console.log(error)
      })
    },

    // backgroundColor () {
    //   console.log(this.recentViewCompanyData)
    //   const color = this.recentViewCompanyData.map(item => item.color)
    //   console.log(color)
    //   return this.bgColor[color]
    // },
    // 销售动态
    getSalesData() {
      this.loading1 = true
      salesData().then(res => {
        this.clueDataObject = res.data.clue
        this.companyDataObject = res.data.company
        if (this.companyDataObject.dayDatas.length > 0) {
          this.clueUnlockChartData = res.data.company.dayDatas.map(item => {
            return item.total
          })
          this.clueUnlockChartXData = res.data.company.dayDatas.map(item => {
            return item.date
          })
        }
        if (this.clueDataObject.dayDatas.length > 0) {
          this.clueGetChartData = res.data.clue.dayDatas.map(item => {
            return item.total
          })
          this.clueGetChartXData = res.data.clue.dayDatas.map(item => {
            return item.date
          })
        }
        this.loading1 = false
      }).catch(error => {
        this.loading1 = false
        console.log(error)
      })
    },

    // 商机订阅
    getSubscribeBusiness() {
      subscribeBusiness().then(res => {
        console.log(res)
      })
    },

    // 全部动态
    getUnlockCompany() {
      this.loading3 = true
      const data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      unlockCompany(data).then(res => {
        // console.log(res, 9090)
        this.pageNum = res.data.pageNum
        this.maxPageNum = res.data.maxPageNum
        this.unlockCompanyData = res.data.unlockVOS
        this.loading3 = false
      }).catch(error => {
        this.loading3 = false
        console.log(error)
      })
    },
    async getcleaningNumberList() {
      let params = {
        pageSize: this.pageSizeC,
        pageNum: this.pageNumC
      }
      this.loading3 = true
      const res = await cleaningNumberList(params)
      if (res.code == 200) {
        this.numberCleaningCompanyData = res.data.records
        // this.pageNumC = res.data.pageNum
        // this.maxPageNumC = res.data.maxPageNum
        this.allTotalC = res.data.total
        this.loading3 = false
      }
    },
    handleCurrentChange(val) {
      if (this.activeName == '1') {
        this.pageNum = val
        this.getUnlockCompany()
      } else {
        this.pageNumC = val
        this.getcleaningNumberList()
      }

    },
    handleSizeChange(val) {
      this.pageSizeC = val
      this.pageNumC = 1
      this.getcleaningNumberList()
    },
    // 解锁来源统计
    getUnlockSource() {
      this.loading2 = true
      unlockSource().then(res => {
        this.pieUnlockSourceData = res.data
        this.loading2 = false
      }).catch(error => {
        console.log(error)
        this.loading2 = false
      })
    },

    // test
    // testUserInfo () {
    //   testUserInfo().then(res => {
    //     console.log(res)
    //   })
    // }
    getNews(name = '珍岛信息技术（上海）股份有限公司') {
      this.searchNewsName = name
      this.loading5 = true
      const data = {
        pageNum: 1,
        pageSize: 6,
        // startTime: this.getDay(-364 / 2),
        // endTime: this.getDay(0),
        name
      }
      getNews(data).then(res => {
        this.news = res.data?.items || []
        this.loading5 = false
      }).catch(error => {
        this.loading5 = false
        console.log(error)
      })
    },
    looksMore() {
      this.$router.push({ name: '企业资讯', params: { name: this.searchNewsName } })
    },
    getDay(day) {
      const today = new Date()
      // eslint-disable-next-line camelcase
      const targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
      today.setTime(targetdayMilliseconds)

      const tYear = today.getFullYear()
      let tMonth = today.getMonth()
      let tDate = today.getDate()
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleMonth(tDate)

      return '' + tYear + tMonth + tDate
    },
    doHandleMonth(month) {
      var m = month
      if (month.toString().length === 1) {
        m = '0' + month
      }
      return m
    }
  }
}
</script>

<style lang="scss" scoped>
.home-index {
  padding-top: 16px;
  display: flex;
  width: 100%;

  .left-main {
    flex: 1;
    margin-right: 16px;
    // float: left;
  }
  .right-main {
    width: 356px;
    flex: 0 auto;
    // float: right;
  }
  .left-box-3-main {
    display: flex;
    .left-box-3 {
      width: 60%;
      float: left;
    }
    .left-box-4 {
      width: calc(40% - 16px);
      float: right;
      margin-left: 16px;
    }
  }
  .card-box {
    box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
    border-radius: 4px;
    background: #ffffff;
    margin-bottom: 16px;
  }

  .m-b16 {
    margin-bottom: 16px;
  }
  .top-a {
    height: 108px;
    .main {
      padding: 0 34px;
      height: 100%;
      display: flex;
      padding-top: 24px;
      // align-items: center;
      justify-content: space-between;
      .item {
        text-align: center;
        cursor: pointer;
        img {
          width: 40px;
          height: 40px;
          // background: red;
          border-radius: 6px;
        }
        p {
          font-size: 13px;
          font-weight: 400;
          color: #343951;
          line-height: 18px;
          margin-top: 8px;
        }
      }
    }
  }

  .left-main-2 {
    padding: 16px 24px;
    height: 178px;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #343951;
      display: flex;
      align-items: center;
      span {
        font-size: 13px;
        font-weight: 400;
        margin-left: 7px;
      }
    }
    .main {
      padding-top: 30px;
      .item {
        display: flex;
        .l {
          flex: 0 180;
          min-width: 140px;
          .sub-title {
            font-size: 13px;
            font-weight: 400;
            color: #343951;
            line-height: 18px;
          }
          .number {
            padding-top: 7px;
            min-width: 140px;
            text-align: right;
            .max {
              font-size: 36px;
              font-weight: bold;
              color: #343951;
              line-height: 42px;
            }
            .min {
              margin-left: 5px;
              font-size: 14px;
              font-weight: 400;
              color: #343951;
              line-height: 20px;
            }
            .min-icon {
              color: #30bf78;
              font-size: 12px;
              margin-left: 4px;
            }
          }
        }
        .r {
          flex: 1;
          padding: 0 20px;

          height: 68px;
          .canvas-main {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .left-main-3 {
    // height: 334px;
    height: 374px;
    padding: 16px 24px;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #343951;
      line-height: 22px;
    }
  }
  .left-main-3-cover {
    position: relative;
    margin-top: 16px;
    width: 100%;
    height: 140px;
    background: #466bff;
    box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
    border-radius: 4px;
    padding: 26px 24px 0 24px;
    // padding-left: 124px;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
      position: relative;
      z-index: 100;
    }
    .desc {
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 17px;
      margin-top: 2px;

      position: relative;
      z-index: 100;
    }
    .but {
      cursor: pointer;
      width: 84px;
      height: 28px;
      background: #ffffff;
      border-radius: 4px;
      margin-top: 16px;
      font-size: 12px;
      font-weight: 400;
      color: #4283f5;
      line-height: 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 100;
    }
  }

  .left-main-4 {
    // height: 490px;
    height: 530px;
    padding: 16px 24px;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #343951;
      line-height: 22px;
    }
    .line {
      margin-top: 12px;
      opacity: 0.1;
      border-bottom: 1px solid #979797;
    }
    .list {
      padding-top: 16px;
      .box {
        span {
          font-size: 13px;
        }
        background: rgba(242, 243, 245, 0.5);
        border-radius: 4px;
        display: flex;
        align-items: center;
        font-size: 13px;
        font-weight: 400;
        color: #666666;
        // line-height: 18px;
        padding: 0 8px;
        line-height: 34px;
        height: 34px;
        margin-bottom: 11px;
        .order-box {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          text-align: center;
          flex: 0 auto;
          font-size: 13px;
          color: #999999;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .a1 {
          margin-left: 10px;
          margin-right: 10px;
          width: 60px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .a2 {
          flex: 1;
        }
        .a3 {
          flex: 0 auto;
          width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: right;
          padding-left: 10px;
        }
      }
      .box:nth-child(1) .order-box {
        color: #ffffff;
        background: linear-gradient(180deg, #ffe55e 0%, #ffc730 100%);
      }
      .box:nth-child(2) .order-box {
        color: #ffffff;
        background: linear-gradient(180deg, #e8e8e8 0%, #cccccc 100%);
      }
      .box:nth-child(3) .order-box {
        color: #ffffff;
        background: linear-gradient(180deg, #f0c3b7 0%, #dd9080 100%);
      }
    }
  }

  .left-main-5 {
    .list {
      padding: 0 24px;
      box-sizing: border-box;
      max-height: 440px;
      overflow: hidden;
      overflow-y: scroll;
      .item {
        .box {
          display: flex;
          font-size: 13px;
          font-weight: 400;
          color: #666666;
          line-height: 18px;
          padding-top: 17px;
          padding-bottom: 18px;
          border-bottom: 1px solid #eeeeee;
          .a1 {
            height: 36px;
          }
          span {
            font-size: 13px;
          }
          .a1 {
          }
          .a2 {
            padding-left: 16px;
            flex: 1;
            .b2 {
              margin: 0 16px;
            }
            .b3 {
              cursor: pointer;
              color: rgba(80, 136, 255, 1);
            }
            span {
              font-size: 13px;
            }
          }
          .a3 {
            font-size: 12px;
            color: #999999;
            padding-top: 4px;
            line-height: 12px;
          }
        }
      }
    }
    /deep/ {
      .el-tabs__header {
        margin-bottom: 7px;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #f4f4f4;
      }
    }
  }
  .page1 {
    text-align: center;
  }
  .left-main-6 {
    .main {
      .top {
        height: 108px;
        background: #446bff;
        padding: 29px 24px 0 24px;
        .title {
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
          line-height: 22px;
        }
        .desc {
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
          margin-top: 4px;
        }
      }
      .tongji {
        padding: 16px 24px 0 24px;
        // height: 169px;
        .box {
          width: 100%;
          background: #f5f6f8;
          border-radius: 8px;
          padding: 8px 20px;
          margin-bottom: 8px;
          .info {
            font-size: 13px;
            font-weight: 400;
            color: #333333;
            display: flex;
            align-items: center;
            justify-content: space-between;
            line-height: 18px;
            .name {
            }
            .number {
              font-size: 12px;
              font-weight: 400;
              color: #666666;
            }
          }
          .progress {
            margin-top: 6px;
          }
        }
        .exp-time {
          padding-bottom: 16px;
          border-bottom: 1px solid #f5f6f8;
          .box1 {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .sub-box {
              font-size: 12px;
              font-weight: 400;
              color: #666666;
              // line-height: 17px;
            }
          }
        }
        &:nth-last-of-type(1) {
          .exp-time {
            border-bottom: none;
          }
        }
      }
    }
  }
  .left-main-7 {
    height: 680px;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #343951;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 11px;
      border-bottom: 1px solid rgba(151, 151, 151, 0.1);
      span,
      p {
        font-size: 16px;
      }
      .sub-title {
        cursor: pointer;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
      }
    }
    .main {
      .item {
        padding: 16px 0;
        border-bottom: 1px solid rgba(151, 151, 151, 0.1);
        padding-top: 24px;
        height: 153px;
        .a1 {
          font-size: 14px;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
          display: block;
        }
        .a2 {
          padding-top: 4px;
          padding-bottom: 2px;
          font-size: 13px;
          font-weight: 400;
          color: #666666;
          line-height: 22px;

          overflow: hidden;

          text-overflow: ellipsis;

          display: -webkit-box;

          -webkit-box-orient: vertical;

          -webkit-line-clamp: 2;
        }
        .a3,
        .a4 {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          span {
            font-size: 12px;
          }
        }
        &.nob {
          border-bottom: none;
        }
      }
      .item:last-child {
        border-bottom: none;
      }
    }
  }
  .left-main-8 {
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #343951;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 11px;
      border-bottom: 1px solid rgba(151, 151, 151, 0.1);
      margin-left: -24px;
      margin-right: -24px;
      padding-left: 24px;
      padding-right: 24px;
      .sub-title {
        cursor: pointer;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
      }
    }
    .list {
      padding-top: 16px;
      .box {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .ixon {
          width: 32px;
          height: 36px;
          font-size: 12px;
          line-height: 14px;
          // background: linear-gradient(180deg, #FFC46C 0%, #F7AD25 100%);
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #fff;
          img {
            // width: 100%;
            // height: 100%;
            max-width: 100%;
            height: 100%;
          }
        }
        .a2 {
          padding-left: 8px;
          font-size: 13px;
          font-weight: 400;
          color: #666666;
          line-height: 18px;
          flex: 1;
        }
        .a3 {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
        }
      }
    }
  }
}
.pointer-events {
  pointer-events: all;
}
.no-data {
  position: relative;
  text-align: center;
  padding: 10px;
  overflow: hidden;
  min-height: 405px;
  .no-data-box {
    width: 100%;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    img {
      width: 64px;
    }
    p {
      color: #aaa;
      font-size: 12px;
      margin-top: 5px;
    }
  }
}
.emptyBox {
  width: 100%;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  img {
    width: 64px;
  }
  p {
    color: #aaa;
    font-size: 12px;
    margin-top: 5px;
  }
}
/deep/ {
  .el-progress-bar__outer {
    background: none;
  }
  .top-a {
    .el-card__body {
      padding: 0;
      height: 100%;
    }
  }
  .left-main-2 {
    .el-card__body {
      padding: 16px 24px;
      padding-bottom: 43px;
    }
  }
  .left-main-3 {
    .el-card__body {
      padding: 16px 24px;
      padding-bottom: 0px;
    }
  }
  .left-main-4 {
    .el-card__body {
      padding: 16px 24px;
      padding-bottom: 0px;
    }
  }
  .left-main-5 {
    // max-height: 545px;
    max-height: 606px;
    .el-card__body {
      // padding: 16px 24px;
      padding: 16px 0px;
      padding-bottom: 2px;
      .el-tabs__active-bar {
        // display: none;
      }
      .el-tabs__item {
        font-weight: 400;
        color: #343951;
        line-height: 22px;
        font-size: 16px;
      }
      .el-tabs__item.is-active {
        font-weight: 600;
        color: #343951;
      }
      .el-tabs__nav-wrap::after {
        display: none;
      }
    }
  }
  .page1 {
    .el-pager li.active,
    .el-pager li:hover {
      // color: rgba(237, 104, 38, 1);
    }
  }
  .left-main-6 {
    .el-card__body {
      padding: 0;
    }
    .el-progress-bar__outer {
      background: #e9f1ff;
    }
    .el-progress-bar__inner {
      background: #5088ff;
    }
  }
  .left-main-7 {
    .el-card__body {
      padding: 16px 24px;
      padding-bottom: 0px;
    }
  }
  .left-main-8 {
    height: 355px;
    .el-card__body {
      padding: 16px 24px;
      padding-bottom: 0px;
    }
  }
}
.emipy {
  text-align: center;
  padding-top: 100px;
  color: #aaa;
  .sub-emipy {
    img {
      width: 64px;
    }
  }
}

.cls001 {
  width: 208px;
  height: 101px;
  position: absolute;
  top: 7px;
  right: 2px;
}
.cls002 {
  position: absolute;
  width: 221px;
  height: 128px;
  top: 12px;
  right: 24px;
}
.page001 {
  text-align: center;
  /deep/ {
    .el-pager li,
    .btn-next,
    .btn-prev {
      min-width: 25px;
      border: none !important;
      background: none !important;
      box-shadow: none;
      &:hover,
      &.active {
        color: rgba(80, 136, 255, 1) !important;
      }
      i {
        font-size: 14px !important;
      }
    }
  }
}

.dongtaimt {
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  margin: auto;
  color: #fff;
  text-align: center;
  background-color: #4f7afd;
}

.right-main.lsHideRight {
  // position: fixed;
  // right: 24px;
  // pointer-events: none;
}
.left-main-5 {
  position: relative;
}
.goList {
  position: absolute;
  right: 24px;
  top: 20px;
  font-size: 12px;
  color: #999999;
}
::v-deep {
  .person-cleaning {
    .el-progress-bar {
      .el-progress-bar__inner {
        right: 0;
        margin: auto;
        left: 0;
        bottom: 0;
        line-height: 10px;
        .el-progress-bar__innerText {
          color: #666666;
          font-size: 8px;
        }
      }
    }
  }
  .cleaningPage {
    .el-pagination__sizes,
    .el-pagination__jump {
      display: none;
    }
    &.pagination {
      padding: 16px !important;
    }
  }
}

@media screen and (min-width: 1680px) {
  .left-main-3-cover {
    padding-left: 124px !important;
    .cls002 {
      right: 97px;
    }
  }
}
.business-subscribe {
  .left-main-8 {
    height: auto;
    .list {
      padding-top: 0;
      padding-bottom: 6px;
      .box {
        padding-top: 16px;
        border-top: 1px solid rgba(151, 151, 151, 0.1);
        margin-bottom: 16px;
        &:nth-of-type(1) {
          border-top: 24px;
        }
        .ixon {
          width: 58px;
          height: 58px;
          border-radius: 2px;
          margin-right: 12px;
          font-size: 18px;
          padding: 6px;
          line-height: 24px;
        }
        .subscribe-txt {
          width: 238px;
          p {
            &.a2 {
              font-weight: bold;
              color: #333333;
              line-height: 22px;
              height: 22px;
              overflow: hidden;
              margin-bottom: 4px;
              padding-left: 0;
              cursor: pointer;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            &.a3 {
              //  height: 24px;
              line-height: 20px;
              background: rgba(80, 136, 255, 0.15);
              border-radius: 2px;
              font-weight: 400;
              color: #5088ff;
              font-size: 12px;
              padding: 0 8px;
              box-sizing: border-box;
              margin-bottom: 4px;
              display: inline-block;
            }
            &.a4 {
              font-size: 12px;
              font-family: ArialMT;
              color: #999999;
            }
          }
        }
      }
    }
  }
  .emptyBox {
    top: 30px;
    img {
      // &.kbImg{
      //   width: 117px;
      //   height: 119px;
      // }
    }
    p {
      margin-bottom: 18px;
    }
    .el-button--primary {
      width: 100px;
    }
  }
}
.nqClueUnlock.item {
  width: 100%;
}
.home-index .left-main-2 .main .nqClueUnlock.item .l .number {
  min-width: 150px;
}
</style>
